"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobBillingHelper = void 0;
const currency_1 = require("../currency");
class JobBillingHelper {
    constructor(job) {
        this.job = job;
    }
    getCombinedRegularAndOTHours() {
        return (this.job.job_billing_sums?.regular_hours ?? 0) +
            (this.job.job_billing_sums?.overtime_hours ?? 0);
    }
    getCombinedRegularAndOTCharge() {
        return (this.job.job_billing_sums?.regular_amount_cents ?? 0) +
            (this.job.job_billing_sums?.overtime_amount_cents ?? 0);
    }
    noOvertimeMultiplier() {
        return this.job.overtime_multiplier === 1.0;
    }
    getCombinedCallbackAndOTCharge() {
        return (this.job.job_billing_sums?.callback_amount_cents ?? 0) +
            (this.job.job_billing_sums?.overtime_amount_cents ?? 0);
    }
    getCombinedCallbackAndOTHours() {
        return (this.job.job_billing_sums?.callback_hours ?? 0) +
            (this.job.job_billing_sums?.overtime_hours ?? 0);
    }
    getOTHours() {
        return this.noOvertimeMultiplier()
            ? this.job.job_billing_sums?.callback_hours ?? 0
            : this.getCombinedCallbackAndOTHours();
    }
    getRegularRateInfo() {
        const regularHours = this.noOvertimeMultiplier()
            ? this.getCombinedRegularAndOTHours()
            : this.job.job_billing_sums?.regular_hours ?? 0;
        const regularAmountCents = this.noOvertimeMultiplier()
            ? this.getCombinedRegularAndOTCharge()
            : this.job.job_billing_sums?.regular_amount_cents ?? 0;
        const regularAmount = (0, currency_1.centsToCurrency)(regularAmountCents);
        const regularRate = regularAmountCents && regularHours ? regularAmountCents / regularHours : null;
        return {
            rate: regularRate ? (0, currency_1.centsToCurrency)(regularRate) : null,
            hours: regularHours,
            totalCents: regularAmountCents,
            amount: regularAmount
        };
    }
    getOvertimeRateInfo() {
        const noOvertime = this.noOvertimeMultiplier();
        const combinedCallbackAndOTHours = this.getCombinedCallbackAndOTHours();
        const combinedCallbackAndOTCharge = this.getCombinedCallbackAndOTCharge();
        const overtimeHours = this.getOTHours();
        const overtimeAmountCents = noOvertime
            ? this.job.job_billing_sums?.callback_amount_cents ?? 0
            : combinedCallbackAndOTCharge;
        const overtimeAmount = (0, currency_1.centsToCurrency)(overtimeAmountCents);
        const overtimeAmountRate = (() => {
            if (noOvertime) {
                return overtimeAmountCents && overtimeHours
                    ? overtimeAmountCents / overtimeHours
                    : null;
            }
            else {
                return combinedCallbackAndOTHours && combinedCallbackAndOTHours
                    ? combinedCallbackAndOTCharge / combinedCallbackAndOTHours
                    : null;
            }
        })();
        const multiplier = this.job.overtime_multiplier;
        return {
            rate: overtimeAmountRate ? (0, currency_1.centsToCurrency)(overtimeAmountRate) : null,
            hours: overtimeHours,
            totalCents: overtimeAmountCents,
            amount: overtimeAmount,
            multiplier
        };
    }
    getDoubleRateInfo() {
        const doubleHours = this.job.job_billing_sums?.double_hours ?? 0;
        const doubleAmountCents = this.job.job_billing_sums?.double_amount_cents ?? 0;
        const doubleAmountRate = doubleAmountCents && doubleHours ? (0, currency_1.centsToCurrency)(doubleAmountCents / doubleHours) : null;
        const multiplier = this.job.double_overtime_multiplier;
        const doubleAmount = (0, currency_1.centsToCurrency)(doubleAmountCents);
        return {
            rate: doubleAmountRate,
            hours: doubleHours,
            totalCents: doubleAmountCents,
            amount: doubleAmount,
            multiplier
        };
    }
    getOnCallRateInfo() {
        const onCallHours = this.job.job_billing_sums?.total_on_call_hours ?? 0;
        const onCallAmountCents = this.job.on_call_hourly_rate_cents && onCallHours
            ? onCallHours * this.job.on_call_hourly_rate_cents
            : 0;
        const onCallAmount = (0, currency_1.centsToCurrency)(onCallAmountCents);
        const averageOnCallRate = onCallAmountCents && onCallHours ? (0, currency_1.centsToCurrency)(onCallAmountCents / onCallHours) : null;
        return {
            rate: averageOnCallRate,
            hours: onCallHours,
            totalCents: onCallAmountCents,
            amount: onCallAmount,
        };
    }
}
exports.JobBillingHelper = JobBillingHelper;
